export default __webpack_public_path__ + "static/media/yealink-t54w.b832cb6a.jpg";